import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { Grid } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { useGetDashboardUrl } from '@/hooks'
import { FileContent } from './components'

export const MenuContent: React.FC = () => {
  const url = useGetDashboardUrl()

  return (
    <>
      <DropdownMenu.Link icon={Grid} title="Go to Dashboard" to={url} />
      <DropdownMenu.Divider />
      <DropdownMenu.NestedMenu content={FileContent} id="file" title="File" />
    </>
  )
}
